import { render } from "./_fancy-next.vue?vue&type=template&id=432720c0"
import script from "./_fancy-next.vue?vue&type=script&lang=js"
export * from "./_fancy-next.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__